<template>
    <div class="container-fluid p-0">
    <div class="w-100 home-header p-0">
        <div class="hero-overlay"></div>
        <div class="home-header-content">
            Tool for impulsive underwater noise (D11-MSFD) 
            monitoring and assessment in the Mediterranean Sea Region
        </div>
    </div>
    <div class="row mt-5">
        <div class="col-lg-6">
            <div class="home-body-content">
            <p><b>About this project</b></p>
            <p style="text-align: justify;">QUIETMED 2: Joint programme for Good Environmental Status (GES) assessment on D11-noise in the Mediterranean Marine Region. This project aims to support Member States Competent Authorities in the assessment of the extent to which GES on D11 has been achieved in the Mediterranean Region to get an updated, improved and more complete regional assessment by providing practical outcomes to implement the 2017/848 Decisions. 
                <br><br>
                The project starts on February 2019 and it will end on February 2021. The consortium is coordinated by Marine Technology Centre and formed by ACCOBAMS, DFMR, IZVRS, HCMR, IOF, UM - The Conservation Biology Research Group, POLIMI - Department of Civil and Environmental Engineering, SSW, SPA/RAC and ICES.
            </p>
            </div>
            <router-link class="position-relative mt-5 pt-5" tag="div" to="/risk" exact>
                <button class="btn btn-primary btn-home-login">Login</button>
            </router-link>  
        </div>
        <div class="col-lg-6">
            <div class="home-body-img" style="-webkit-box-shadow: 3px 3px 5px 6px #ccc; -moz-box-shadow: 3px 3px 5px 6px #ccc; box-shadow: 3px 3px 5px 6px #ccc;">
                <img  class="image-cover" :src="require('@/assets/images/home-image.png')" alt="home-picture"/>
            </div> 
        </div>
    </div>
    </div>
</template>

<script>
  export default {
    data(){
      return {
      }
    },
    methods: {
    },
    /*beforeMount(){
      this.$store.dispatch('refresh_token')
    },*/
  }
</script>